var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterTwitterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2175 0.269287H14.4665L9.5531 5.88495L15.3333 13.5266H10.8075L7.26265 8.89198L3.20659 13.5266H0.956247L6.21158 7.52002L0.666626 0.269287H5.30737L8.51156 4.50551L12.2175 0.269287ZM11.4282 12.1805H12.6744L4.63022 1.54471H3.29293L11.4282 12.1805Z",
    fill: "#7F9AA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTwitterIcon);
export default __webpack_public_path__ + "static/media/footer-twitter-icon.50f0a56af4165f03c694fdda248a2219.svg";
export { ForwardRef as ReactComponent };